import React from 'react'
import { Main } from './components'

const Printers = () => <Main />

export default Printers
